import * as THREE from "three";

async function loadJSON(path) {
  // Don't catch errors, some flightpaths are supposed to be missing
  return await fetch(path).then((response) => response.json());
}

export async function loadCurveFromJSON(jsonPath) {
  let curveJSON = await loadJSON(jsonPath);
  return curveJSON
    ? {
        curve: createCurveFromJSON(curveJSON),
        center: findCenterPoint(curveJSON)
      }
    : null;
}

function createCurveFromJSON(json) {
  // Extract the vertices array from the JSON object
  const vertices = json.points;

  // Create an empty array to store THREE.Vector3 instances
  const points = vertices.map((v) => new THREE.Vector3(v.x, v.y, v.z));

  // Create a CatmullRomCurve3 using the points array
  const curve = new THREE.CatmullRomCurve3(points);

  curve.closed = json.closed;

  return curve;
}

/**
 * Finds the approximate center point of a curve
 *
 * @param {*} json curve data for bird
 * @returns center point of curve
 */
function findCenterPoint(json) {
  const numberOfPoints = json.points.length;
  const total = new THREE.Vector3(0, 0, 0);

  json.points.forEach((point) => {
    total.add(new THREE.Vector3(point.x, point.y, point.z));
  });

  // Calculating the average for each coordinate
  return total.divideScalar(numberOfPoints);
}
